import { useEffect, useSyncExternalStore, type ReactNode } from 'react';
import { isPublicPath } from '../public-paths';
import type { AdminSessionState } from '../session-store';
import { useRuntime } from './runtime-provider';

/** The back-office session (who is signed in, the CSRF token): changes re-render the reader. */
export function useAdminSession(): AdminSessionState {
  const { sessionStore } = useRuntime();
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.getState, sessionStore.getState);
}

/**
 * Loads GET /platform/me once. The sign-in outcome page (/signed-out) has no session: nothing is
 * loaded for it.
 */
export function SessionProvider({ children }: { children?: ReactNode }) {
  const { sessionStore, navigation } = useRuntime();

  useEffect(() => {
    if (isPublicPath(navigation.currentPath())) return;
    if (sessionStore.getState().status === 'idle') void sessionStore.bootstrap();
  }, [sessionStore, navigation]);

  return children;
}
